import Matter from "matter-js"
import { PendantProductVarantBuilderDataMetafield, PendantProduct, MainProduct } from "../../types"
import { getPendantProductVariantById } from "..";

export const DEVICE_PIXEL_RATIO = 2;

const ENGINE_CONSTRAINT_ITERATIONS = 18;
const ENGINE_POSITION_ITERATIONS = 12;
const ENGINE_VELOCITY_ITERATIONS = 8;

const CHAIN_FRICTION = 0;
const CHAIN_FRICTION_AIR = 0.04;
const CHAIN_RESTITUTION = 0;

const PENDANT_FRICTION = 0;
const PENDANT_FRICTION_AIR = 0.04;
const PENDANT_RESTITUTION = 0;

export const createEngine = () => Matter.Engine.create({
  constraintIterations: ENGINE_CONSTRAINT_ITERATIONS,
  positionIterations: ENGINE_POSITION_ITERATIONS,
  velocityIterations: ENGINE_VELOCITY_ITERATIONS,
})
export const createRender = (engine: Matter.Engine, canvas: HTMLCanvasElement) => {
  return Matter.Render.create({
    canvas,
    engine,
    options: {
      width: 800,
      height: 800,
      wireframes: false,
      // background: "#f2f1ed",
      pixelRatio: DEVICE_PIXEL_RATIO
    }
  })
}

export const getPendantData = (pendantProducts: PendantProduct[], variantId: string): PendantProductVarantBuilderDataMetafield => {
  const allPendantProductVariants = pendantProducts.flatMap(pendantProduct => pendantProduct.variants)

  const pendantProductVariant = allPendantProductVariants.find(variant => String(variant.id) === String(variantId))!

  return pendantProductVariant.metafields.builderData
}

export const FRONT_CHAIN_TEXTURE_WIDTH = 40 / 2 / 2
export const FRONT_CHAIN_TEXTURE_HEIGHT = 29 / 2 / 2
export const SIDE_CHAIN_TEXTURE_WIDTH = 40 / 2 / 2
export const SIDE_CHAIN_TEXTURE_HEIGHT = 10 / 2 / 2

export const createChainBody = (x: number, y: number, width: number, height: number, texture: string, label: string) => Matter.Bodies.rectangle(
  x, 
  y, 
  width, 
  height, 
  {
    friction: CHAIN_FRICTION,
    frictionAir: CHAIN_FRICTION_AIR,
    restitution: CHAIN_RESTITUTION,
    collisionFilter: { group: -1 },
    render: { 
      sprite: { 
        // Texture size = base size * DEVICE_PIXEL_RATIO. 
        texture, 
        xScale: 1 / DEVICE_PIXEL_RATIO, 
        yScale: 1 / DEVICE_PIXEL_RATIO 
      } 
    },   
    label                 
  }
);

export const createPendant = (x: number, y: number, pendantProducts: PendantProduct[], activePendantProductVaraintId: string, mainProduct: MainProduct) => {
  const { width, height } = getPendantData(pendantProducts, activePendantProductVaraintId) 

  const { textureUrl: texture } = getPendantProductVariantById(mainProduct, activePendantProductVaraintId)

  return Matter.Bodies.rectangle(x, y, width, height,
    {
      label: `pendant/${activePendantProductVaraintId}`,
      friction: PENDANT_FRICTION,
      frictionAir: PENDANT_FRICTION_AIR,
      restitution: PENDANT_RESTITUTION,
      collisionFilter: { group: -1 },
      render: {
        sprite: {
          texture,
          // Texture size = base size * DEVICE_PIXEL_RATIO.
          xScale: 1 / DEVICE_PIXEL_RATIO,
          yScale: 1 / DEVICE_PIXEL_RATIO,
        }
      },
    }
  )
}
